import { UPLOAD_FILE_FOR_REPORT } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPLOAD_FILE_FOR_REPORT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_FILE_FOR_REPORT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPLOAD_FILE_FOR_REPORT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
